import React from "react";
import "./Blog_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

function Blog_card({ baseLink, blogData }) {
  return (
    <>
      <Link to={baseLink}>
        <section className="Blog_card">
          <div className="main_content_holder">
            <div className="img_holder">
              <img
                className="Blog_img"
                src={process.env.REACT_APP_IMG_URL + blogData.image}
                alt={"Blog_img"}
              />
            </div>
            <div className="text_holder">
              <p className="title_text heading_text">{blogData.name}</p>
              <p className="descn para_text">{blogData.subname}</p>
              <p className="para_text">
                    {parse(
                      typeof blogData?.description === "string"
                        ? blogData.description
                        : ""
                    )}
                  </p>
            </div>
          </div>

          {/* old code */}
          {/* <>
            <div className="img_holder">
              <img
                className="Blog_img"
                src={process.env.REACT_APP_IMG_URL + blogData.image}
                alt={"Blog_img"}
              />

              <FontAwesomeIcon className="arrow_icon" icon={faArrowRight} />
            </div>
            <div className="text_holder">
              <h4>{blogData.name}</h4>
              <p>{blogData.subname}</p>
            </div>
          </> */}
        </section>
      </Link>
    </>
  );
}

export default Blog_card;
